<template>
    <div class="sub-carousel">
        <div class="card submission-card">
            <div v-if="!numbered || !!header_text" class="card-header">
                <div class="row">
                    <div class="col" v-if="!!header_text">
                    <span>{{ header_text }}</span>
                    </div>
                    <div class="col" v-if="!numbered">
                    <span class="float-right">This submission will be posted with no numbering</span>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <span v-html="text"></span>
                <br>
                <template v-if="image_url">
                    <div v-if="this.nsfwImage" class="row m-4">
                        <div class="col text-center">
                            <button v-on:click="toggleImage" class="btn btn-warning">{{ this.showImage ? "Hide" : "Show" }} NSFW-flagged image</button>
                        </div>
                    </div>
                    <img v-if="this.showImage" class="submittedImage d-block mx-auto img-fluid" :src="image_url" />
                </template>
            </div>
            <div class="card-footer py-0 text-muted text-center" 
                v-bind:class="{ 'bg-warning': secondOp || trialEditor }">
                <div class="row align-items-center">
                    <div v-if="index > 0" class="col-2 left slide-control" href="#carouselApprove" role="button" v-on:click="$emit('decrement-carousel-index')"><i class="fa fa-angle-left"></i></div>
                    <div v-else class="col-2 left slide-control invisible"><i class="fa fa-angle-left"></i></div>
                    <div class="col-8">
                        <span class="descriptiveText">Submitted: </span>{{ submissionTimeHumanReadable }}
                        <i v-if="hit_filter" class="fa fa-flag text-danger"></i>
                    </div>
                    <div v-if="index < indexMax -1" class="col-2 right slide-control" href="#carouselApprove" role="button" v-on:click="$emit('increment-carousel-index')"><i class="fa fa-angle-right"></i></div>
                    <div v-else class="col-2 right slide-control invisible"><i class="fa fa-angle-right"></i></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MobileSubmissionCard",

    props: {
        index: {
            type: Number,
            required: true,
        },
        indexMax: {
            type: Number,
            required: true,
        },
        id: {
            type: Number,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
        image_url: {
            type: String,
        },
        submission_time: {
            type: String,
            required: true,
        },
        hit_filter: {
            type: Boolean,
            default: false,
        },
        secondOp: {
            type: Boolean,
            default: false,
        },
        trialEditor: {
            type: Boolean,
            default: false,
        },
        route_truth_details: {
            type: String,
            required: true,
        },
        secondaryPages: {
            type: Array,
            default: () => []
        },
        header_text: {
            type: String
        },
        numbered: {
            type: Boolean,
            required: true
        },
        nsfw_probability: {
            type: Number
        },
        instagram: {
            type: Boolean,
            default: null
        }
    },
    
    data() {
        return {
            nsfwImage: this.image_url && this.nsfw_probability > 0.95,
            showImage: !(this.image_url && this.nsfw_probability > 0.95)
        }
    },

    methods: {
        toggleImage: function() {
            this.showImage = !this.showImage;
        },
        timeDiff: function(datestamp) {
            let localDateTime = new Date(datestamp + "Z");
            return Math.floor((localDateTime - Date.now()) / 1000);
        },
        humanReadableTime: function(seconds) {
            let times = {           // Seconds in:
                "years": 31536000,  // a year
                "months": 2628000,  // a month
                "weeks": 604800,    // a week
                "days": 86400,      // a day
                "hours": 3600,      // an hour
                "minutes": 60,      // a minute
            }
            let future = seconds >= 0;
            seconds = Math.abs(seconds);
            for (let time in times) {
                let interval = Math.floor(seconds/times[time]);
                if (interval >= 1) {
                    if (interval === 1) {
                        time = time.slice(0, -1);
                    }
                    return `${interval} ${time} ${future ? 'from now' : 'ago'}`;
                }
            }
            return `${Math.floor(seconds)} seconds ${future ? 'from now' : 'ago'}`;
        },
    },
    computed: {
        submissionTimeHumanReadable: function() {
            return this.humanReadableTime(this.timeDiff(this.submission_time));
        },
    },
}
</script>